import { render, staticRenderFns } from "./OzScreenSizeAwarePopoverModal.vue?vue&type=template&id=634e5acf&"
import script from "./OzScreenSizeAwarePopoverModal.vue?vue&type=script&lang=ts&"
export * from "./OzScreenSizeAwarePopoverModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports